import { AppState } from '../../index';
import { STATE_KEY } from './constants';
import { ServiceState } from './model';

export const selectRequestor = (state: AppState): ServiceState => state[STATE_KEY];
